export default __webpack_public_path__ + "static/media/logo-quickbooks.1637dde7.png";